
import ProfileRemove from "../../../assets/duotone/ProfileRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ProfileRemoveIcon({ className, dataTestid = "ProfileRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ProfileRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
